import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const d=l("philippines",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5V12.5L3.73333 20.3222L0 4.5Z"
                fill="#0038A8" />
            <path
                d="M3.73333 12.5L24 12.5L24 20.5H0L3.73333 12.5Z"
                fill="#CE1126" />
            <path
                d="M10.392 12.5L0 20.5L0 4.5L10.392 12.5Z"
                fill="white" />
            <path
                d="M5.01893 13.7227C5.52558 13.7227 5.9363 13.1751 5.9363 12.4995C5.9363 11.824 5.52558 11.2764 5.01893 11.2764C4.51228 11.2764 4.10156 11.824 4.10156 12.4995C4.10156 13.1751 4.51228 13.7227 5.01893 13.7227Z"
                fill="#FCD116" />
            <path
                d="M5.02132 12.4996L4.69922 10.3373L4.79503 10.2082L4.90206 10.075L5.02132 9.91602L5.14058 10.075L5.2476 10.2082L5.34342 10.3373L5.02132 12.4996Z"
                fill="#FCD116" />
            <path
                d="M5.02132 12.499L5.34342 14.6613L5.2476 14.7904L5.14058 14.9236L5.02132 15.0826L4.90206 14.9236L4.79503 14.7904L4.69922 14.6613L5.02132 12.499Z"
                fill="#FCD116" />
            <path
                d="M5.02344 12.4998L6.64514 12.0703L6.74198 12.1981L6.84187 12.3408L6.96112 12.4998L6.84187 12.6588L6.74198 12.8015L6.64514 12.9292L5.02344 12.4998Z"
                fill="#FCD116" />
            <path
                d="M5.02362 12.4998L3.40192 12.9292L3.30509 12.8015L3.2052 12.6588L3.08594 12.4998L3.2052 12.3408L3.30509 12.1981L3.40192 12.0703L5.02362 12.4998Z"
                fill="#FCD116" />
            <path
                d="M5.01664 12.4994L5.93503 10.666H6.07162L6.21738 10.6728H6.38556V10.8971L6.39066 11.0914V11.2735L5.01562 12.498L5.01664 12.4994Z"
                fill="#FCD116" />
            <path
                d="M5.01855 12.499L4.10016 14.3324H3.96357L3.81781 14.3256H3.64963V14.1014L3.64453 13.907V13.7249L5.01957 12.5004L5.01855 12.499Z"
                fill="#FCD116" />
            <path
                d="M5.01953 12.5004L6.39457 13.7249V13.907L6.38947 14.1014V14.3256H6.22128L6.07552 14.3324H5.93894L5.02055 12.499L5.01953 12.5004Z"
                fill="#FCD116" />
            <path
                d="M5.01957 12.5L3.64453 11.2755V11.0934L3.64963 10.899V10.6748H3.81781L3.96357 10.668H4.10016L5.01855 12.5013L5.01957 12.5Z"
                fill="#FCD116" />
            <path
                d="M9.19098 12.4997L8.84645 12.66L8.83932 13.1466L8.61915 12.7592L8.26953 12.9006L8.47849 12.501L8.26953 12.1015L8.61915 12.2428L8.83932 11.8555L8.84645 12.342L9.19098 12.5024V12.4997Z"
                fill="#FCD116" />
            <path
                d="M2.62252 17.5573L2.69081 17.0789L2.37891 16.8275L2.74076 16.7663L2.82434 16.292L2.97927 16.7323L3.34316 16.6916L3.07713 17.0245L3.21881 17.473L2.89875 17.2379L2.62252 17.5559V17.5573Z"
                fill="#FCD116" />
            <path
                d="M2.62252 7.44277L2.89875 7.76079L3.21881 7.52567L3.07713 7.97416L3.34316 8.30713L2.97927 8.26636L2.82434 8.7067L2.74076 8.23238L2.37891 8.17122L2.69081 7.9198L2.62252 7.44141V7.44277Z"
                fill="#FCD116" />
        </svg>
    `),f=l("philippines_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92913)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-1.94141 0.5L46.0586 0.5V12.5L5.52526 24.2333L-1.94141 0.5Z"
                    fill="#0038A8" />
                <path
                    d="M5.52526 12.5L46.0586 12.5V24.5L-1.94141 24.5L5.52526 12.5Z"
                    fill="#CE1126" />
                <path
                    d="M18.8426 12.5L-1.94141 24.5L-1.94141 0.5L18.8426 12.5Z"
                    fill="white" />
                <path
                    d="M8.09646 14.3345C9.10975 14.3345 9.93119 13.5131 9.93119 12.4998C9.93119 11.4865 9.10975 10.665 8.09646 10.665C7.08316 10.665 6.26172 11.4865 6.26172 12.4998C6.26172 13.5131 7.08316 14.3345 8.09646 14.3345Z"
                    fill="#FCD116" />
                <path
                    d="M8.09732 12.4994L7.45312 9.25599L7.64475 9.06232L7.85881 8.86254L8.09732 8.62402L8.33584 8.86254L8.54989 9.06232L8.74152 9.25599L8.09732 12.4994Z"
                    fill="#FCD116" />
                <path
                    d="M8.09732 12.499L8.74152 15.7424L8.54989 15.9361L8.33584 16.1359L8.09732 16.3744L7.85881 16.1359L7.64475 15.9361L7.45312 15.7424L8.09732 12.499Z"
                    fill="#FCD116" />
                <path
                    d="M8.09766 12.4997L11.3411 11.8555L11.5347 12.0471L11.7345 12.2612L11.973 12.4997L11.7345 12.7382L11.5347 12.9522L11.3411 13.1439L8.09766 12.4997Z"
                    fill="#FCD116" />
                <path
                    d="M8.09803 12.4997L4.85462 13.1439L4.66095 12.9522L4.46117 12.7382L4.22266 12.4997L4.46117 12.2612L4.66095 12.0471L4.85462 11.8555L8.09803 12.4997Z"
                    fill="#FCD116" />
                <path
                    d="M8.09969 12.5001L9.93647 9.75H10.2096L10.5012 9.76019H10.8375V10.0966L10.8477 10.3881V10.6613L8.09766 12.498L8.09969 12.5001Z"
                    fill="#FCD116" />
                <path
                    d="M8.09959 12.5L6.26282 15.2501H5.98964L5.69812 15.2399H5.36176V14.9035L5.35156 14.612V14.3388L8.10163 12.502L8.09959 12.5Z"
                    fill="#FCD116" />
                <path
                    d="M8.09766 12.5001L10.8477 14.3369V14.61L10.8375 14.9016V15.2379H10.5012L10.2096 15.2481H9.93647L8.09969 12.498L8.09766 12.5001Z"
                    fill="#FCD116" />
                <path
                    d="M8.09772 12.5L5.34766 10.6632V10.39L5.35785 10.0985V9.76215H5.69422L5.98574 9.75195H6.25891L8.09569 12.502L8.09772 12.5Z"
                    fill="#FCD116" />
                <path
                    d="M16.4445 12.4995L15.7554 12.7401L15.7411 13.4699L15.3008 12.8889L14.6016 13.1009L15.0195 12.5015L14.6016 11.9022L15.3008 12.1142L15.7411 11.5332L15.7554 12.263L16.4445 12.5036V12.4995Z"
                    fill="#FCD116" />
                <path
                    d="M3.30754 20.0854L3.44412 19.3678L2.82031 18.9907L3.54401 18.899L3.71118 18.1875L4.02105 18.848L4.74883 18.7868L4.21675 19.2863L4.50012 19.959L3.86 19.6064L3.30754 20.0834V20.0854Z"
                    fill="#FCD116" />
                <path
                    d="M3.30754 4.91415L3.86 5.39118L4.50012 5.0385L4.21675 5.71124L4.74883 6.2107L4.02105 6.14954L3.71118 6.81004L3.54401 6.09857L2.82031 6.00684L3.44412 5.6297L3.30754 4.91211V4.91415Z"
                    fill="#FCD116" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92913">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{d as Philippines,f as PhilippinesRounded};
